// extracted by mini-css-extract-plugin
module.exports = {"successPane":"SuccessPane_successPane__28amx"};